import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Confirmation } from './models/confirmation-model';

@Component({
  selector: 'app-confirmationDialog',
  templateUrl: './confirmDialog.component.html'
})

export class ConfirmationDialogComponent implements OnInit {
  model: Confirmation;

  constructor(public dialogRef: MatDialogRef<ConfirmationDialogComponent>
             ,@Inject(MAT_DIALOG_DATA) public data: any) { }


  ngOnInit(): void {
    this.init();
  }

  init(): void {
    this.model = {
      header: this.data.confirmation.header ? this.data.confirmation.header : 'Potvrda',
      width: this.data.confirmation.widht ? this.data.confirmation.width : '60vw',
      message: this.data.confirmation.message ? this.data.confirmation.message : 'Da li ste sigurni?',
      acceptLabel: this.data.confirmation.acceptLabel ? this.data.confirmation.acceptLabel : 'Nastavi',
      rejectLabel: this.data.confirmation.rejectLabel ? this.data.confirmation.rejectLabel : 'Odustani',
      acceptDisabled: this.data.confirmation.acceptDisabled ? this.data.confirmation.acceptDisabled : false
    };
  }

  close(): void {
    this.dialogRef.close(false);
  }

  confirm(): void {
    this.dialogRef.close(true);
  }
}
